import React from 'react';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';

const getLayout = (presets = {}) => {
  const vehicle = {
    name: 'vehicleId',
    label: 'Vehicle',
    required: true,
    readOnly: true,
  };

  const assignee = {
    name: 'assignedTo',
    label: 'Assigned To',
    // readOnlyOnInit: true,
    validation: {
      type: 'db',
      modelName: 'Salesperson',
      format: 'user',
    },
    control: 'dbselect',
  };

  const deal = {
    name: 'dealId',
    label: 'Add To Existing Deal',
    validation: {
      type: 'db',
      modelName: 'EQS2',
      emptyOption: { label: 'New Deal', value: '' },
    },
    control: 'dbselect',
    readOnly: true,
  };

  if (presets.vehicle) {
    vehicle.data = presets.vehicle;
  }

  if (presets.assignee) {
    assignee.data = presets.assignee;
    // assignee.readOnlyOnInit = true; // TODO dont set for manager
  }

  if (presets.deal) {
    deal.data = presets.deal;
    deal.readOnly = true;
    deal.hidden = false;
  }

  return [
    deal,
    vehicle,
    { type: 'number', label: '# of Copies', name: 'copies', data: 1 },
    assignee,
    // { control: 'checkbox', label: 'Continue working on this quote', name: 'continue', data: 'Y' },
  ];
};

const CopyQuote = ({ quote, submitCallback }) => {
  const handleSubmit = payload => {
    return ApiService.post(`/crm/quote/${quote.id}/copy`, { ...payload }).then(() => {
      modal.close();

      if (submitCallback) {
        submitCallback();
      }
    });
  };

  return (
    <div className="copy-quote">
      <Form
        layout={getLayout({ deal: quote.dealId, vehicle: quote.vehicleId, assignee: quote.assignedTo })}
        trackDirty={false}
        onCancel={() => modal.close()}
        submit={handleSubmit}
        submitLabel="Create"
        exportFormat="object"
        useDirtyWarning={false}
        submitAll
        showHelp={false}
      />
    </div>
  );
};

export default CopyQuote;
